import { useNavigate } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import {
  IconArrowRightIndicator,
  Stack,
  Heading,
  Text,
  Shimmer,
  Spot,
  IconWallet,
  Button,
} from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import { getBalance } from '@/features/user/api/balance'
import { formatCurrency } from '@/shared/helpers'
import { SLIM_ROUTES } from '@/shared/routes'
import IbanCopy from '@/features/user/components/IbanCopy'

const UserInfo = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { data, isPending } = useQuery({
    queryKey: ['balance'],
    queryFn: getBalance,
  })

  return (
    <Stack direction='horizontal' justify='space-between' align='center'>
      <Stack direction='horizontal' space='16' align='center'>
        <Spot color='teal' size='large'>
          <IconWallet />
        </Spot>
        <Stack direction='vertical' space='4'>
          <Text>{t('user.mainAccount')}</Text>
          {isPending ? (
            <Shimmer width={120} height={36} />
          ) : (
            <Heading level={2} variant='standard'>
              {data
                ? formatCurrency({
                    value: data.availableAmount.value,
                    currency: data.availableAmount.currency,
                    locale: i18n.resolvedLanguage,
                  })
                : '—'}
            </Heading>
          )}
          {data && <IbanCopy iban={data.accountIban} />}
        </Stack>
      </Stack>
      <Button
        trailingIcon={<IconArrowRightIndicator />}
        onClick={() => navigate(SLIM_ROUTES.TRANSFER)}
      >
        {t('user.sendMoney')}
      </Button>
    </Stack>
  )
}

export default UserInfo
